import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

export const PointOfInterestIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
  direction,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''} ${direction || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="point-of-interest-icon"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M5.794 16.518a9 9 0 1112.724-.312l-6.206 6.518-6.518-6.206zm11.276-1.691l-4.827 5.07-5.07-4.827a7 7 0 119.897-.243z"
        clipRule="evenodd"
      />
      <path
        fill={fill}
        d="M15.13 7.393a2.345 2.345 0 00-3.09.44 2.355 2.355 0 00-3.09-.44 2.175 2.175 0 00-.68.742A2.146 2.146 0 008 9.1c0 1.547 1.333 2.794 3.454 4.69a.813.813 0 001.09 0C14.667 11.895 16.05 10.648 16 9.1a2.145 2.145 0 00-.234-.953 2.172 2.172 0 00-.635-.754z"
      />
    </svg>
  );
};

export default PointOfInterestIcon;
